import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaHome, FaBars } from "react-icons/fa";
import LanguageSelector from "./LanguageSelector.jsx";
import config from "../config.js";
import { useLanguage } from "../Context.jsx";

export default function Header() {
  const [menu, setMenu] = useState([]);

  const { language } = useLanguage();

  const fetchMenu = async () => {
    try {
      const response = await fetch(
        `${config.apiUrl}contentapi.php?option=1&type=5`
      );

      const data = await response.json();

      setMenu(data);
    } catch (error) {
      console.error("Error fetching menu data:", error);
    }
  };

  useEffect(() => {
    fetchMenu();
  }, []);

  const groupedLinks = menu.reduce((acc, item) => {
    const existingCategory = acc.find(
      (cat) => cat.categoryE === item.CategoryE
    );

    if (existingCategory) {
      existingCategory.subcatLinks.push({
        subcategory: item.SubCategory,
        subcategoryd: item.SubCategoryd,
        subcategoryp: item.SubCategoryp,
      });
    } else {
      acc.push({
        categoryE: item.CategoryE,
        categoryP: item.CategoryP,
        categoryD: item.CategoryD,
        subcatLinks: [
          {
            subcategory: item.SubCategory,
            subcategoryd: item.SubCategoryd,
            subcategoryp: item.SubCategoryp,
          },
        ],
      });
    }

    return acc;
  }, []);

  const catLinksMenu = groupedLinks.map((link, index) => {
    return (
      <li
        key={index}
        className="nav-item dropdown px-2 px-lg-3"
        id="border-end"
      >
        <a
          className="nav-link dropdown-toggle text-white"
          href={"#"}
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {parseInt(language) === 1 ? link.categoryD : link.categoryP}
        </a>
        <ul
          className="dropdown-menu dropdown-menu-end text-end"
          style={{ zIndex: "2000" }}
        >
          {link.subcatLinks.map((sublink, index) => {
            return (
              <li key={index}>
                <Link
                  to={`/${link.categoryE}/${sublink.subcategory}`}
                  className="dropdown-item"
                >
                  {parseInt(language) === 1
                    ? sublink.subcategoryd
                    : sublink.subcategoryp}
                </Link>
              </li>
            );
          })}
          <li>
            <hr className="dropdown-divider" />
          </li>
          <li>
            <Link className="dropdown-item" to={`/${link.categoryE}`}>
              {parseInt(language) === 1
                ? `تمام ${link.categoryD}`
                : `ټول ${link.categoryP}`}
            </Link>
          </li>
        </ul>
      </li>
    );
  });

  return (
    <div className="primary-bg-blue sticky-top">
      <div className="max-container-width">
        {/* Nav links */}
        <div className="navbar-color w-100 px-lg-0 d-flex justify-content-between align-items-center">
          <nav
            className="text-white navbar navbar-expand-lg"
            id="navbar-height"
          >
            <button
              className="navbar-toggler me-2 my-1 border-secondary-subtle py-2 px-3"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span>
                <FaBars style={{ color: "white", opacity: "80%" }} />
              </span>
            </button>
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul
                className="navbar-nav mt-2 mt-lg-0 pe-0"
                style={{ fontSize: "1.2rem" }}
              >
                <li className="nav-item px-2 px-lg-3">
                  <Link to="/all" className="nav-link text-white">
                    <FaHome />
                  </Link>
                </li>
                {/* mapping for links to show on navbar */}
                {catLinksMenu}
              </ul>
            </div>
          </nav>
          <LanguageSelector />
        </div>
      </div>
    </div>
  );
}
